angular.module('app.mail')
  .controller('MailController', MailController);

function MailController(Users, Mail, $templateCache) {

  let vm = this;

  console.log($templateCache.get('modules/mail/mail.html'));

  // Setup the base variables that the controller will act on.
  vm.user = Users.get();
  vm.recipient = '';
  vm.subject = '';
  vm.body = '';

  // methods
  vm.send = function() {
    Mail.send(vm.recipient, vm.user.email, vm.subject, vm.body).then(function(response) {
      if (response.data.err) {
        vm.error = true;
        vm.message = 'You message could not be sent.';
      } else {
        vm.notice = true;
        vm.message = 'You message was sent successfully.';
        vm.recipient = '';
        vm.subject = '';
        vm.body = '';
      }

    });
  };
}
